import { Admin as AdminModel } from '@models/Admin'
import { selectAdminById } from '@store/AdminReducer'
import { useAppSelector } from '@store/hooks'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Space, Typography } from 'antd'
import { AvatarProps } from 'antd/es/avatar'
import { FC } from 'react'

const { Text } = Typography

type Props = SBModelComponent<AdminModel> & {
  size?: AvatarProps['size']
  type?: 'full' | 'condensed'
}

const AdminAvatar: FC<Props> = ({
  id,
  model,
  size = 'default',
  type = 'full',
}) => {
  const item = model ? model : useAppSelector(selectAdminById(id!))

  if (!item) {
    return <></>
  }

  return (
    <Space orientation="horizontal">
      {type == 'full' && (
        <Space.Compact orientation="horizontal">
          <Text>
            {item.firstName} {item.lastName}
          </Text>
        </Space.Compact>
      )}
    </Space>
  )
}

type AdminAvatarType = { Avatar: typeof AdminAvatar }

export { AdminAvatar, type AdminAvatarType }
